export default __webpack_public_path__ + "static/media/email-box.50644bf8.svg";